import { FieldType } from "../api.js";
import { SelfEntityModelConvertSpec } from "./account.specs.js";
const ProfileResponseConvertSpecs = {
  self: SelfEntityModelConvertSpec,
  latestDepositAmount: FieldType.Number
};
export {
  ProfileResponseConvertSpecs
};
